<template>
  <div class="article-featured-text-container" :class="containerClasses">
    <div :id="navId" class="article-featured-text" :class="classes">
      <div class="text">
        <div v-if="subHeading" class="article-featured-text__type">
          {{ subHeading }}
        </div>
        <div class="slots">
          <slot v-if="activeSlot === 1" name="content"></slot>
          <slot v-else-if="activeSlot === 2" name="content-es"></slot>
          <template v-if="contentReadMoreExists">
            <div
              :class="{
                'readMore--hidden': !readMore,
                'readMore--show': readMore,
              }"
            >
              <slot name="content-read-more"></slot>
            </div>
            <button class="read-more-button" @click="toggleReadMore">
              {{ readMoreButton }}
            </button>
          </template>
        </div>
        <p v-if="author" class="author">Words by {{ author }}</p>
        <p v-if="author2" class="author2">{{ author2 }}</p>
        <Button
          v-if="linkButton"
          tag="a"
          :href="link"
          target="_blank"
          class="linkButton"
        >
          {{ linkButton }}
        </Button>
        <button
          v-if="contentEsExists"
          class="langButton"
          :class="langButtonClasses"
          @click="toggleSlot"
        >
          <span>EN</span> |
          <span>ES</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
export default {
  name: "ArticleFeatureText",
  components: {
    Button,
  },
  props: {
    navId: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    subHeading: {
      type: String,
      default: null,
    },
    author: {
      type: String,
      default: null,
    },
    author2: {
      type: String,
      default: null,
    },
    heading: {
      type: Boolean,
      default: false,
    },
    standout: {
      type: Boolean,
      default: false,
    },
    centered: {
      type: Boolean,
      default: false,
    },
    withText: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Boolean,
      default: false,
    },
    withDisplay: {
      type: Boolean,
      default: false,
    },
    linkButton: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    backgroundBlack: {
      type: Boolean,
      default: false,
    },
    fontSize36px: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeSlot: 1,
      readMore: false,
    };
  },
  computed: {
    containerClasses() {
      return {
        "article-featured-text-container--background-black":
          this.backgroundBlack,
        "article-featured-text-container--font-size-36px": this.fontSize36px,
        "article-featured-text-container--block": this.block,
      };
    },
    classes() {
      return {
        "article-featured-text--heading": this.heading,
        "article-featured-text--standout": this.standout,
        "article-featured-text--centered": this.centered,
        "article-featured-text--withText": this.withText,
        "article-featured-text--maxWidth": this.maxWidth,
        "article-featured-text--withDisplay": this.withDisplay,
      };
    },
    langButtonClasses() {
      return {
        "langButton--en": this.activeSlot === 1,
        "langButton--es": this.activeSlot === 2,
      };
    },
    contentEsExists() {
      return !!this.$slots["content-es"];
    },
    contentReadMoreExists() {
      return !!this.$slots["content-read-more"];
    },
    readMoreButton() {
      return this.readMore ? "Read Less" : "Read More";
    },
  },
  methods: {
    toggleSlot() {
      console.log("toggleSlot");
      this.activeSlot = this.activeSlot === 1 ? 2 : 1;
    },
    toggleReadMore() {
      this.readMore = !this.readMore;
    },
  },
};
</script>

<style lang="scss" scoped>
.article-featured-text-container {
  margin: 0 20px;
  &--background-black {
    .article-featured-text {
      margin: 0 auto;
      max-width: 1560px;
      padding: 0;
      .text {
        max-width: 100%;
        background-color: #000;
        padding: 0 0 90px;
      }
      .slots {
        color: $color-white;
        padding: 80px 0 0;
        text-align: center;
        margin: auto;
        max-width: 855px;
        :deep(p) {
          display: inline;
          font-size: 64px;
        }
        :deep(span) {
          font-family: $heading-font-family;
          font-size: 64px;
          display: inline;
          font-style: italic;
        }
      }
      .linkButton {
        color: $color-white;
        display: block;
      }
      .author2 {
        color: $color-white;
      }
    }
  }
  &--font-size-36px {
    margin: 0 20px 15px;
    @include respond-above(md) {
      margin: 0 20px 80px;
    }
    .article-featured-text {
      .slots {
        :deep(p) {
          display: inline;
          font-size: 20px;
          @include respond-above(md) {
            font-size: 36px;
          }
        }
        :deep(span) {
          font-size: 20px;
          display: inline;
          font-style: italic;
          @include respond-above(md) {
            font-size: 36px;
          }
        }
      }
    }
  }

  &--block {
    margin: 0;
    @include respond-above(md) {
      margin: 0 20px 2px;
    }
  }
}

.article-featured-text {
  padding: 0 0 45px;

  @include respond-above(md) {
    padding: 0 20px 65px;
  }

  &--withText {
    padding-bottom: 20px;
  }

  &--heading {
    padding: 0 20px 20px;
    @include respond-above(md) {
      padding: 0 20px 80px;
    }
  }

  &__type {
    color: $color-grey-dark;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.55px;
    margin: 0 0 10px;
    text-transform: uppercase;
  }

  .wysiwyg :deep() {
    color: $color-grey-dark;
    font-family: $heading-font-family;

    font-weight: 400;

    h4 {
      @include t__editorial-headline-10;
      margin-bottom: 20px;
      text-transform: uppercase;

      @include respond-above(md) {
        @include t__editorial-headline-20;
      }
    }

    h5 {
      font-size: 16px;
      margin-bottom: 10px;
      @include respond-above(md) {
        font-size: 18px;
      }
    }

    p {
      @include t__editorial-body-10;
      margin-bottom: 20px;
      @include respond-above(md) {
        @include t__editorial-body-20;
      }
    }

    *:last-child {
      margin-bottom: 0;
    }
  }

  &--standout {
    .wysiwyg :deep() {
      p {
        font-size: 20px;
        margin-bottom: 20px;
        @include respond-above(md) {
          font-size: 24px;
        }
      }
    }
  }
  &--centered {
    text-align: center;
  }

  &--withDisplay {
    padding-bottom: 40px;
  }

  &--maxWidth {
    max-width: 800px;
    margin: 0 auto;
    :deep(h4) {
      margin-bottom: 20px;
    }
  }
}

.text {
  @include respond-above(md) {
    margin: 0 auto;
    max-width: 1200px;
  }
}

.author {
  @include t__utility-label-30;
  margin: 15px 0 0 0;

  @include respond-above(md) {
    margin: 20px 0 0 0;
  }
}

.slots {
  :deep(h3) {
    font-size: 28px;
    font-family: $heading-font-family;
    text-transform: uppercase;
    font-weight: 400;
    margin: 0 0 20px;
  }
  :deep(h4) {
    @include t__editorial-headline-10;
    margin-bottom: 10px;
    text-transform: uppercase;

    @include respond-above(md) {
      @include t__editorial-headline-20;
    }
  }
  :deep(p) {
    @include t__editorial-body-10;
    margin-bottom: 15px;
    @include respond-above(md) {
      @include t__editorial-body-20;
    }
  }

  :deep(a) {
    display: inline;
    @include t__editorial-body-10;
    @include respond-above(md) {
      @include t__editorial-body-20;
    }
  }

  :deep(span) {
    display: block;
    font-family: $heading-font-family;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 130%;
    font-style: italic;
    margin-bottom: 15px;
    @include respond-above(md) {
      font-size: 18px;
    }
  }

  :slotted(p + h4) {
    margin-top: 30px;

    @include respond-above(md) {
      margin-bottom: 10px;
      margin-top: 60px;
    }
  }
  :slotted(p + a) {
    display: inline;
  }
  :slotted(a + p) {
    display: inline;
  }
}
.langButton {
  background: none;
  border: none;
  font-family: $heading-font-family;
  font-size: 18px;
  font-weight: 400;
  padding: 0;
  margin-top: 20px;
  text-align: left;
  @include respond-above(md) {
    font-size: 20px;
  }

  &--en span:first-child {
    font-weight: 700;
  }

  &--es span:last-child {
    font-weight: 700;
  }
}

.linkButton {
  padding: 0;
  color: $color-grey-dark;
  text-decoration: underline;
  border: none;
  background: none;
}
.author2 {
  margin: 40px 0 0;
  border: none;
  background: none;
  color: $color-grey-dark;
  display: block;
  font-family: $utility-font-family;
  text-align: center;
  text-wrap: pretty;
}
.readMore {
  &--hidden {
    display: none;
  }
  &--show {
    display: block;
  }
}
.read-more-button {
  background: none;
  border: none;
  font-family: $utility-font-family;
  font-size: 20px;
  font-weight: 400;
  padding: 0;
  text-decoration: underline;
}
:deep(p.styled-p) {
  display: inline;
}
</style>
